import React from "react";
import "./buttonsStyle.css";

// Generic button component for icon, text, or both

const IconAndTextButton = ({
  icon,
  text,
  iconPos = "left",
  clsNames = "",
  custStyles = {},
  iconStyles = {},
  textStyles = {},
  onClickFn,
  disabled = false,
  type = "button",
}) => {
  // Process icon if provided
  const iconElement =
    icon &&
    (typeof icon === "string" ? (
      <img src={icon} alt="" style={iconStyles} />
    ) : React.isValidElement(icon) ? (
      React.cloneElement(icon, { style: { ...iconStyles } })
    ) : (
      icon
    ));

  return (
    <button
      type={type}
      className={clsNames}
      style={custStyles}
      onClick={onClickFn}
      disabled={disabled}
    >
      {iconPos === "left" && icon && iconElement}

      {text && <span style={textStyles}>{text}</span>}

      {iconPos === "right" && icon && iconElement}
    </button>
  );
};

export default IconAndTextButton;
